<template>
  <div class="body-wrapper community-tickets">
    <div class="table-wrapper">
      <spinner
        class="spinner"
        line-fg-color="#00796b"
        :size="100"
        :line-size="6"
        v-if="loading"
      ></spinner>

      <div v-if="!loading">
        <button
          v-if="$router.history.current.name == 'communityTickets'"
          @click="showModal('ModalContentTicket')"
          class="btn btn-filter"
        >
          Novi tiket
        </button>

        <i
          v-if="filterActive"
          class="fas fa-times filter-icon-out"
          @click="refreshTableAndFilterDropdown"
        ></i>
        <div class="filter-search">
          <div
            ref="filterDropdown"
            class="dropdown"
            :class="{ show: dropdownActive }"
          >
            <button
              @click="openFilter"
              class="btn btn-secondary btn-filter"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              :class="{ 'red-filter': filterActive }"
            >
              Filter
            </button>

            <div
              class="dropdown-menu"
              :class="{ show: dropdownActive }"
              aria-labelledby="dropdownMenuButton"
            >
              <div class="checkboxes">
                <div class="privacy-filter">
                  <h6>Privatnost</h6>
                  <div class="options">
                    <template v-for="option of privacy">
                      <div
                        class="option-holder"
                        :key="'privacyDiv' + option.id"
                      >
                        <input
                          v-bind:id="'privacyCheckbox' + option.id"
                          :key="'privacyInput' + option.id"
                          type="checkbox"
                          name="private"
                          value="option.value"
                          v-model="option.isChecked"
                        />
                        <label
                          v-bind:for="'privacyCheckbox' + option.id"
                          :key="'privacyLabel' + option.id"
                          >{{ option.value }}</label
                        >
                      </div>
                    </template>
                  </div>
                </div>
                <hr />
                <div class="status-filter">
                  <h6>Status</h6>
                  <div class="options status">
                    <template v-for="option of status">
                      <div class="option-holder" :key="'statusDiv' + option.id">
                        <input
                          v-bind:id="'statusCheckbox' + option.id"
                          :key="'statusInput' + option.id"
                          type="checkbox"
                          name="private"
                          value="option.value"
                          v-model="option.isChecked"
                        />
                        <label
                          v-bind:for="'statusCheckbox' + option.id"
                          :key="'statusLabel' + option.id"
                          >{{ option.value }}</label
                        >
                      </div>
                    </template>
                  </div>
                </div>
                <hr />
                <div class="priority-filter">
                  <h6>Prioritet</h6>
                  <div class="options">
                    <template v-for="option of priority">
                      <div class="option-holder" :key="'priorDiv' + option.id">
                        <input
                          v-bind:id="'priorCheckbox' + option.id"
                          :key="'priorInput' + option.id"
                          type="checkbox"
                          name="private"
                          value="option.value"
                          v-model="option.isChecked"
                        />
                        <label
                          v-bind:for="'priorCheckbox' + option.id"
                          :key="'priorLabel' + option.id"
                          >{{ option.value }}</label
                        >
                      </div>
                    </template>
                  </div>
                </div>
                <hr />
              </div>

              <div class="contractor-filter" v-if="allContractors.length > 0">
                <h6>Serviser</h6>
                <select class="form-control custom-select" v-model="contractor">
                  <option value="" disabled>Izaberite servisera</option>
                  <option
                    v-for="contractor in allContractors"
                    :key="contractor.id"
                    :value="contractor.id"
                    >{{ contractor.name }}</option
                  >
                  >
                </select>
                <hr />
              </div>

              <div
                class="contractor-filter"
                v-if="allInfrastructure.length > 0"
              >
                <h6>Infrastruktura</h6>
                <select
                  class="form-control custom-select"
                  v-model="infrastructure"
                >
                  <option value="" disabled>Izaberite infrastrukturu</option>
                  <option
                    v-for="infra in allInfrastructure"
                    :key="infra.id"
                    :value="infra.id"
                    >{{ infra.name }}</option
                  >
                  >
                </select>
                <hr />
              </div>

              <div class="dates">
                <h6>Datum od</h6>
                <div class="date">
                  <datetime
                    @focus="errorOccurred = false"
                    v-model="dateFrom"
                    type="date"
                    input-class="form-control form-control-lg"
                    placeholder="Izaberite datum"
                    hidden-name="webstorm"
                    value-zone="UTC+1"
                    format="dd.MM.yyyy"
                    :phrases="{
                      ok: 'U redu',
                      cancel: 'Otkaži'
                    }"
                  ></datetime>
                  <i class="fas fa-times" @click="dateFrom = null"></i>
                </div>
                <h6>Datum do</h6>
                <div class="date">
                  <datetime
                    @focus="errorOccurred = false"
                    v-model="dateTo"
                    type="date"
                    input-class="form-control form-control-lg"
                    placeholder="Izaberite datum"
                    hidden-name="webstorm"
                    value-zone="UTC+1"
                    format="dd.MM.yyyy"
                    :phrases="{
                      ok: 'U redu',
                      cancel: 'Otkaži'
                    }"
                  ></datetime>
                  <i class="fas fa-times" @click="dateTo = null"></i>
                </div>
                <div class="validation-text" v-if="dateTo && dateTo < dateFrom">
                  Krajnji datum ne može biti pre početnog.
                </div>
              </div>
              <div class="footer-filter">
                <button
                  @click="setFilterQueryParams"
                  class="btn btn-secondary btn-go left"
                  type="button"
                  :disabled="
                    dateTo < dateFrom &&
                      dateTo != null &&
                      dateTo != '' &&
                      dateFrom != null &&
                      dateFromo != ''
                  "
                >
                  Primeni filter
                </button>
                <button
                  @click="refreshTableAndFilterDropdown"
                  class="btn btn-secondary btn-go"
                  type="button"
                >
                  Resetuj filter
                </button>
              </div>
            </div>
          </div>
          <input
            type="text"
            class="form-control search-input"
            placeholder="Pretraži"
            v-model="search"
            @input="searching"
          />
        </div>
        <data-table
          :columns="tableColumns"
          :tableData="tableData"
          :options="tableOptions"
          :slotNamePriority="'priority_id'"
          :slotNameStatus="'current_status'"
          :slotNameAction="'action'"
          :slotNamePrivacy="'privacy'"
          :slotDate="'timestamp'"
          @sort="sort"
        ></data-table>
        <div class="pagination-wrapper">
          <pagination
            v-if="tableCount / perPage > 1"
            :totalCount="tableCount"
            :perPage="perPage"
            :currentPage="currentPage"
            @pageChanged="changePage"
          ></pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner';
import DataTable from '@/components/community/Table';
import Pagination from '../common/Pagination.vue';
import { mapMutations, mapActions, mapState } from 'vuex';
import { Datetime } from 'vue-datetime';
import { DateTime } from 'luxon';
import 'vue-datetime/dist/vue-datetime.css';
import { Settings } from 'luxon';
import axios from '@/axios/axios';

export default {
  components: {
    DataTable,
    Spinner,
    Datetime,
    Pagination
  },

  data() {
    return {
      currentPage: 1,
      pageChangedMethod: false,
      filterActive: false,
      perPage: 10,
      searchFlag: true,
      search: '',
      dropdownActive: false,
      dateFrom: null,
      dateTo: null,
      contractor: '',
      allContractors: [],
      infrastructure: '',
      allInfrastructure: [],
      status: [
        { id: 1, value: 'Nov', isChecked: false },
        { id: 2, value: 'Otvoren', isChecked: false },
        { id: 3, value: 'U toku', isChecked: false },
        { id: 4, value: 'Zatvoren', isChecked: false }
      ],
      priority: [
        { id: 1, value: 'Nizak', isChecked: false },
        { id: 2, value: 'Srednji', isChecked: false },
        { id: 3, value: 'Visok', isChecked: false }
      ],
      privacy: [
        { id: 1, value: 'Privatni', value_id: '1', isChecked: false },
        { id: 2, value: 'Javni', value_id: '0', isChecked: false }
      ]
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('table', [
      'tableColumns',
      'tableData',
      'tableOptions',
      'tableCount'
    ])
  },
  async created() {
    // setting badge of active view (tickets)
    this.setTableBadge('fas fa-ticket-alt');
    this.allContractors = await this.getAllContractors(false);
    //setting up table options and table column names
    if (this.$router.history.current.name === 'communityTickets') {
      this.initTable('ticketsTable');
      this.allInfrastructure = await this.getAllInfrastructure({
        communityId: this.$store.getters.getActiveCommunity.community_id,
        returnOnlyData: true
      });
    } else {
      this.initTable('tableAllTickets');
    }
    const routeParams = this.$route.query;
    this.dateFrom = routeParams.date_from;
    this.dateTo = routeParams.date_to;
    this.status.map(s => {
      if (routeParams.status && routeParams.status.indexOf(s.value) != -1) {
        s.isChecked = true;
      }
      return s;
    });
    this.priority.map(p => {
      if (routeParams.priority && routeParams.priority.indexOf(p.id) != -1) {
        p.isChecked = true;
      }
      return p;
    });
    this.privacy.map(p => {
      if (routeParams.privacy == p.value_id) {
        p.isChecked = true;
      }
      return p;
    });
    this.contractor = routeParams.contractor_id
      ? routeParams.contractor_id
      : '';
    this.infrastructure = routeParams.infrastructure_id
      ? routeParams.infrastructure_id
      : '';
    this.filterActive = routeParams.filterActive;
  },
  destroyed() {
    //unsetting badge when view is closed
    this.setTableBadge('');
    document.removeEventListener('click', this.closeFilter);
  },
  methods: {
    ...mapMutations('table', [
      'setTableBadge',
      'setRestructuredTableData',
      'setTableCount'
    ]),
    ...mapActions('table', [
      'initTable',
      'getTicketsByCommunity',
      'getAllContractors',
      'getAllInfrastructure'
    ]),
    ...mapMutations(['loadingStarted']),
    ...mapMutations('modal', ['showModal']),
    async getCommunityTickets(params) {
      const response = await axios.get(
        `/community/${
          this.$store.getters.getActiveCommunity.id
        }/infrastructures-with-contractors`
      );
      const infrastructures = response.data.data;
      axios
        .get(
          `tickets?member_id=${
            this.$store.getters.getActiveCommunity.member_id
          }`,
          {
            params
          }
        )
        .then(res => {
          res.data.data.withCommunity = false;
          res.data.data = res.data.data.map(t => {
            t.infrastructureName = '/';
            if (t.community_infrastructure_id) {
              const infra = infrastructures.find(
                i => i.id == t.community_infrastructure_id
              );
              if (infra) {
                t.infrastructureName = infra.name;
              }
            }
            return t;
          });
          this.setRestructuredTableData(res.data.data);
          if (!this.pageChangedMethod) {
            this.setTableCount(res.data.count);
          }
        })
        .catch(err => {
          let data = [];
          data.withCommunity = false;
          this.setRestructuredTableData(data);
          console.log(err);
        });
    },
    async getAllTickets(params) {
      const response = await axios.get(
        `/community/${
          this.$store.getters.getActiveCommunity.id
        }/infrastructures-with-contractors`
      );
      const infrastructures = response.data.data;
      axios
        .get(`tickets/user?`, { params })
        .then(res => {
          res.data.data.withCommunity = true;
          res.data.data = res.data.data.map(t => {
            t.infrastructureName = '/';
            if (t.community_infrastructure_id) {
              const infra = infrastructures.find(
                i => i.id == t.community_infrastructure_id
              );
              if (infra) {
                t.infrastructureName = infra.name;
              }
            }
            return t;
          });
          this.setRestructuredTableData(res.data.data);

          if (!this.pageChangedMethod) {
            this.setTableCount(res.data.count);
          }
        })
        .catch(err => {
          console.log(err);
          let data = [];
          data.withCommunity = true;
          this.setRestructuredTableData(data);
          console.log(err);
        });
    },
    openFilter() {
      this.dropdownActive = !this.dropdownActive;
      if (this.dropdownActive) {
        document.addEventListener('click', this.closeFilter);
      } else {
        document.removeEventListener('click', this.closeFilter);
      }
    },
    closeFilter(e) {
      if (!this.$refs.filterDropdown.contains(e.target)) {
        this.dropdownActive = false;
        document.removeEventListener('click', this.closeFilter);
      }
    },
    getPrivacy() {
      let privacy = this.privacy.filter(e => e.isChecked);
      return privacy.length !== 1 ? null : privacy[0].value_id;
    },
    getPriority() {
      return this.priority.filter(e => e.isChecked).map(e => e.id);
    },
    getStatus() {
      return this.status.filter(e => e.isChecked).map(e => e.value);
    },
    setFilterQueryParams() {
      if (
        this.getStatus().length !== 0 ||
        this.getPriority().length !== 0 ||
        this.getPrivacy() ||
        this.dateTo ||
        this.dateFrom ||
        this.contractor ||
        this.infrastructure
      ) {
        this.pageChangedMethod = false;
        this.filterActive = true;
        let params = {
          search: this.search,
          status: this.getStatus(),
          priority: this.getPriority(),
          privacy: this.getPrivacy(),
          date_from: this.dateFrom === '' ? null : this.dateFrom,
          date_to: this.dateTo === '' ? null : this.dateTo,
          filterActive: this.filterActive
        };
        if (this.contractor) {
          params.contractor_id = this.contractor;
        }
        if (this.infrastructure) {
          params.infrastructure_id = this.infrastructure;
        }
        if (this.$router.history.current.name === 'communityTickets') {
          this.$router.replace({
            name: 'communityTickets',
            query: params
          });
        } else {
          this.$router.replace({
            name: 'tickets',
            query: params
          });
          this.$router.go();
        }
      } else {
        if (this.$router.history.current.name === 'communityTickets') {
          this.$router.replace({
            name: 'communityTickets'
          });
        } else {
          this.$router.replace({
            name: 'tickets'
          });
          this.$router.go();
        }
      }
    },
    refreshTableAndFilterDropdown() {
      if (this.$router.history.current.name === 'communityTickets') {
        this.$router.replace({
          name: 'communityTickets'
        });
      } else {
        this.$router.replace({
          name: 'tickets'
        });
        this.$router.go();
      }
    },
    sort(payload) {
      this.pageChangedMethod = false;
      let params = {
        search: this.search,
        status: this.getStatus(),
        priority: this.getPriority(),
        privacy: this.getPrivacy(),
        date_from: this.dateFrom === '' ? null : this.dateFrom,
        date_to: this.dateTo === '' ? null : this.dateTo,
        order_condition: payload.orderCondition,
        order_direction: payload.orderDirection
      };
      if (this.$router.history.current.name === 'communityTickets') {
        this.getCommunityTickets(params);
      } else {
        this.getAllTickets(params);
      }
      this.currentPage = 1;
    },
    searching() {
      if (this.search.trim().length > 2) {
        this.pageChangedMethod = false;
        this.searchFlag = false;
        let params = {
          search: this.search,
          status: this.getStatus(),
          priority: this.getPriority(),
          privacy: this.getPrivacy(),
          date_from: this.dateFrom === '' ? null : this.dateFrom,
          date_to: this.dateTo === '' ? null : this.dateTo
        };
        if (this.$router.history.current.name === 'communityTickets') {
          this.getCommunityTickets(params);
        } else {
          this.getAllTickets(params);
        }
        this.currentPage = 1;
      } else {
        if (!this.searchFlag) {
          let params = {
            status: this.getStatus(),
            priority: this.getPriority(),
            privacy: this.getPrivacy(),
            date_from: this.dateFrom === '' ? null : this.dateFrom,
            date_to: this.dateTo === '' ? null : this.dateTo
          };
          this.searchFlag = true;
          if (this.$router.history.current.name === 'communityTickets') {
            this.getCommunityTickets(params);
          } else {
            this.getAllTickets(params);
          }
          this.currentPage = 1;
        }
      }
    },
    changePage(pageNumber) {
      this.currentPage = pageNumber;
      let params = {
        search: this.search,
        status: this.getStatus(),
        priority: this.getPriority(),
        privacy: this.getPrivacy(),
        date_from: this.dateFrom === '' ? null : this.dateFrom,
        date_to: this.dateTo === '' ? null : this.dateTo,
        offset: (pageNumber - 1) * 10
      };
      this.pageChangedMethod = true;

      if (this.$router.history.current.name === 'communityTickets') {
        this.getCommunityTickets(params);
      } else {
        this.getAllTickets(params);
      }
    }
  }
};
</script>

<style lang="scss">
.community-tickets {
  .table-wrapper {
    position: relative;
  }

  .pagination-wrapper {
    display: flex;
    text-align: center;
    align-content: center;
  }

  .pagination {
    margin: auto;
  }
  .spinner {
    padding-top: 10%;
  }
  .btn-filter {
    background: var(--primary-color);
    color: white;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
  .btn-filter :focus :active {
    box-shadow: none;
  }

  .red-filter {
    background-color: #cc0033 !important;
  }

  .dropdown {
    position: absolute;
    right: 240px;
    width: 90px;
  }

  .dropdown-menu {
    width: 300px;
    padding: 1em 1em;
    border: 1px solid var(--primary-color);
    overflow: hidden;
  }

  .dropdown-menu.show {
    top: 38px;
  }
  .checkboxes label {
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    margin-left: 3px;
    margin-bottom: 0;
  }
  .checkboxes hr {
    border-top: 1px solid var(--primary-color-lighten);
  }
  .contractor-filter hr {
    border-top: 1px solid var(--primary-color-lighten);
  }
  .checkboxes .options {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  .checkboxes .options.status {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .checkboxes .option-holder {
    // display: inline-block;
    margin-right: 6px;
  }

  #dropdownMenuButton {
    background: var(--primary-color);
    border: none;
  }

  #dropdownMenuButton:active:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten);
  }

  #dropdownMenuButton:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten);
  }

  .vdatetime-popup {
    position: absolute;
    top: 5% !important;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
  }
  .vdatetime-calendar__month {
    min-height: 257px;
  }

  .vdatetime-calendar__month__day--selected > span > span,
  .vdatetime-calendar__month__day--selected:hover > span > span {
    background: var(--primary-color);
  }

  .vdatetime-popup__actions__button {
    color: var(--primary-color);
  }

  .vdatetime-time-picker__item--selected {
    color: var(--primary-color);
  }

  .vdatetime-month-picker__item--selected {
    color: var(--primary-color);
  }

  .vdatetime-popup__header {
    background: var(--primary-color);
  }
  .footer-filter {
    position: relative;
    display: flex;
    height: 35px;
  }

  .btn-go {
    margin-top: 5px;
    position: absolute;
    right: 0;
    &.left {
      left: 0;
      background: var(--primary-color);
    }
  }
  .btn-sort {
    margin-top: 5px;
    position: absolute;
    left: 0;
    background: var(--primary-color);
    color: white;
  }

  input.vdatetime-input.form-control.form-control-lg {
    height: 35px;
    width: 235px;
    margin-bottom: 7px;
    margin-right: 10px;
    font-size: inherit;
  }

  h6 {
    text-align: center;
  }
  .date {
    display: flex;
    align-items: center;
    align-content: center;
  }

  i {
    margin-bottom: 9px;
    cursor: pointer;
  }

  .fas.fa-sync-alt.filter-icon {
    position: absolute;
    right: 0;
    padding-right: 21px;
  }

  i:hover {
    color: var(--primary-color);
  }

  .sort-box {
    width: 50px;
    height: 50px;
    color: red;
  }

  .search-input {
    position: absolute;
    right: 2px;
    width: 240px;
  }

  .table-class {
    padding-top: 50px;
  }

  .fas.fa-times.filter-icon-out {
    position: absolute;
    padding-top: 10px;
    right: 350px;
  }

  .dates {
    .validation-text {
      margin-top: -6px;
      color: red;
      font-size: 12px;
    }
  }
}
</style>
